import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { viewUserEnquiry } from "../../Redux/Actions/enquiriesAction";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import "./viewUserEnquiry.css";

const ViewUserEnquiry = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const enquiryState = useSelector((state) => state.enquiries || {});

  const [status, setStatus] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (id) dispatch(viewUserEnquiry(id));
    else console.warn("No user enquiry ID found in URL");
  }, [dispatch, id]);

  useEffect(() => {
    if (enquiryState.enquiryDetails) {
      // No status field in response, so do not set status here
      setStatus(""); // or keep it empty
    }
  }, [enquiryState.enquiryDetails]);

  const data = enquiryState.enquiryDetails || {};

  // Extract user and project info from data
  const user = data.user || {};
  const project = data.project || {};


  return (
    <div className="view-enquiry-container">
      <div className="view-enquiry-grid padding-20 gap-10 grid-container">
        <div style={{ gridColumn: "3/8" }}>
          <SearchBar style={{ width: "max-content" }} />
        </div>

        <div className="view-enquiry-header back-icon margin-0 gap-10 align-center flex-container">
          <Link to="/enquiry">
            <BackIcon style={{ cursor: "pointer" }} />
          </Link>
          <div className="view-enquiry-title-section referral-view">
            <h3 className="view-enquiry-main-title">User Enquiry Details</h3>
            <h4 className="view-enquiry-breadcrumb">Enquiries / List / View</h4>
          </div>
        </div>

        <div
          className={`view-enquiry-content overall-container ${
            isUpdating ? "updating" : ""
          }`}
        >
          <div className="enquiry-info-grid">
            <div className="enquiry-info-item">
              <span className="enquiry-info-label">Name</span>
              <h2 className="enquiry-info-value">{user.name || "No Data"}</h2>
            </div>
            <div className="enquiry-info-item">
              <span className="enquiry-info-label">Email</span>
              <h2 className="enquiry-info-value">{user.email || "No Data"}</h2>
            </div>
            <div className="enquiry-info-item">
              <span className="enquiry-info-label">Phone</span>
              <h2 className="enquiry-info-value">{user.contact_number || "No Data"}</h2>
            </div>

            <div className="enquiry-info-item">
              <span className="enquiry-info-label">Project Name</span>
              <h2 className="enquiry-info-value">{project.project_name || "No Data"}</h2>
            </div>

            <div className="enquiry-info-item full-width">
              <span className="enquiry-info-label">Project Address</span>
              <h4 className="enquiry-info-value enquiry-message">
                {project.street_address || "No Data"}
              </h4>
            </div>

            <div className="enquiry-info-item">
              <span className="enquiry-info-label">Date</span>
              <h2 className="enquiry-info-value">
                {data.created_at ? new Date(data.created_at).toLocaleString() : "No Data"}
              </h2>
            </div>
          </div>

          {/* Status Dropdown - removed since no status in response */}

        </div>
      </div>
    </div>
  );
};

export default ViewUserEnquiry;
